/* global logger */
/* eslint-disable class-methods-use-this */

const { cloneDeep } = require('lodash');

// if else config type - 1. overAll || 2. individual

// 1. Over All
// add S+D+L+C
// 1.1. if (deductible > loss)
// 1.1.a. keep charges as it is
// 1.1.b. no entry for deductable
// 1.1.c. no entry for insurance claim
// 1.2. else-if (Insurance_threshold > Loss > Deductibles)
// 1.2.a. keep charges as zero
// 1.2.b. entry for deductable eq deductable charge
// 1.2.c. no entry for insurance claim
// 1.3. else-if (Loss > Insurance_threshold)
// 1.3.a. keep charges as zero
// 1.3.b. entry for deductable eq deductable charge
// 1.3.c. entry for insurance claim eq charge

// 2. Individual
// for each  S/D/L/C
// 2.1. if (deductible > loss)
// 2.1.a. keep charges as it is
// 2.1.b. no entry for deductable
// 2.1.c. no entry for insurance claim
// 2.2. else-if (Insurance_threshold > Loss > Deductibles)
// 2.2.a. keep charge as zero
// 2.2.b. entry for deductable eq deductable charge
// 2.2.c. no entry for insurance claim
// 2.3. else-if (Loss > Insurance_threshold)
// 2.3.a. keep charge as zero
// 2.3.b. entry for deductable eq deductable charge
// 2.3.c. entry for insurance claim eq charge

class Deductibles {
  static getDeductibleCharges(data, chargeData) {
    const charges = cloneDeep(chargeData);
    const deductibleConfig = data.deductablesConfig;
    if (!deductibleConfig) {
      return charges;
    }
    const isOverAllThreshold = (deductibleConfig.type === 'OVERALL');
    if (isOverAllThreshold) {
      // 1. Over All config enabled
      const deductibleCharge = deductibleConfig.threshold.over_all.deductible;
      const insuranceThreshold = deductibleConfig.threshold.over_all.insurance_threshold;
      let sdlcTotal = 0;
      // add S+D+L+C
      charges.forEach((paymentCharge) => {
        if (paymentCharge.cartonDamage && !isNaN(paymentCharge.cartonDamage)) {
          sdlcTotal += parseFloat(paymentCharge.cartonDamage);
        }
        if (paymentCharge.damage && !isNaN(paymentCharge.damage)) {
          sdlcTotal += parseFloat(paymentCharge.damage);
        }
        if (paymentCharge.shortage && !isNaN(paymentCharge.shortage)) {
          sdlcTotal += parseFloat(paymentCharge.shortage);
        }
      });
      const loss = sdlcTotal;
      if (deductibleCharge === 0 && insuranceThreshold !== 0 && loss > insuranceThreshold) {
        charges.forEach((paymentCharge) => {
          paymentCharge.aboveThreshold = {};
          let destinationTotal = 0;
          if (paymentCharge.cartonDamage && !isNaN(paymentCharge.cartonDamage)) {
            destinationTotal += parseFloat(paymentCharge.cartonDamage);
            paymentCharge.aboveThreshold.cartonDamage = true;
          }
          if (paymentCharge.damage && !isNaN(paymentCharge.damage)) {
            destinationTotal += parseFloat(paymentCharge.damage);
            paymentCharge.aboveThreshold.damage = true;
          }
          if (paymentCharge.shortage && !isNaN(paymentCharge.shortage)) {
            destinationTotal += parseFloat(paymentCharge.shortage);
            paymentCharge.aboveThreshold.shortage = true;
          }
          paymentCharge.deductibleCharge = Deductibles
            .getBifurcatedCharges(deductibleCharge, destinationTotal, loss) || 0;
        });
      } else if (deductibleCharge > loss) {
        // Do Nothing
      } else if ((insuranceThreshold >= loss) && (loss > deductibleCharge) && (deductibleCharge !== 0)) {
        charges.forEach((paymentCharge) => {
          paymentCharge.aboveDeductibles = {};
          let destinationTotal = 0;
          if (paymentCharge.cartonDamage && !isNaN(paymentCharge.cartonDamage)) {
            destinationTotal += parseFloat(paymentCharge.cartonDamage);
            paymentCharge.aboveDeductibles.cartonDamage = true;
          }
          if (paymentCharge.damage && !isNaN(paymentCharge.damage)) {
            destinationTotal += parseFloat(paymentCharge.damage);
            paymentCharge.aboveDeductibles.damage = true;
          }
          if (paymentCharge.shortage && !isNaN(paymentCharge.shortage)) {
            destinationTotal += parseFloat(paymentCharge.shortage);
            paymentCharge.aboveDeductibles.shortage = true;
          }
          paymentCharge.deductibleCharge = Deductibles
            .getBifurcatedCharges(deductibleCharge, destinationTotal, loss) || 0;
        });
      } else if (loss > insuranceThreshold && insuranceThreshold !== 0) {
        charges.forEach((paymentCharge) => {
          paymentCharge.aboveThreshold = {};
          let destinationTotal = 0;
          if (paymentCharge.cartonDamage && !isNaN(paymentCharge.cartonDamage)) {
            destinationTotal += parseFloat(paymentCharge.cartonDamage);
            paymentCharge.aboveThreshold.cartonDamage = true;
          }
          if (paymentCharge.damage && !isNaN(paymentCharge.damage)) {
            destinationTotal += parseFloat(paymentCharge.damage);
            paymentCharge.aboveThreshold.damage = true;
          }
          if (paymentCharge.shortage && !isNaN(paymentCharge.shortage)) {
            destinationTotal += parseFloat(paymentCharge.shortage);
            paymentCharge.aboveThreshold.shortage = true;
          }
          paymentCharge.deductibleCharge = Deductibles
            .getBifurcatedCharges(deductibleCharge, destinationTotal, loss) || 0;
        });
      } else if (deductibleCharge > insuranceThreshold) {
        logger.error(`Deductible (${deductibleCharge}) cannot be greater that insuranceThreshold (${insuranceThreshold})`);
      } else {
        logger.info('Deductible set to zero');
      }
    } else {
      const loss = {
        shortage: 0,
        damage: 0,
        cartonDamage: 0,
      };
      const deductibles = {
        shortage: 0,
        damage: 0,
        cartonDamage: 0,
      };
      const chargeKeys = ['shortage', 'damage', 'cartonDamage'];
      const destinationTotals = {};
      charges.forEach((paymentCharge) => {
        let destinationTotal = 0;
        chargeKeys.forEach((chargeName) => {
          if (paymentCharge[chargeName] && !isNaN(paymentCharge[chargeName])) {
            loss[chargeName] += parseFloat(paymentCharge[chargeName]);
            destinationTotal += parseFloat(paymentCharge[chargeName]);
          }
        });
        destinationTotals[paymentCharge.destinationId] = destinationTotal;
      });
      chargeKeys.forEach((chargeName) => {
        const deductibleCharge = deductibleConfig.threshold[chargeName].deductible;
        const insuranceThreshold = deductibleConfig.threshold[chargeName].insurance_threshold;
        if (deductibleCharge === 0 && insuranceThreshold !== 0 && loss[chargeName] > insuranceThreshold) {
          charges.forEach((paymentCharge) => {
            if (!paymentCharge.aboveThreshold) {
              paymentCharge.aboveThreshold = {};
            }
            if (paymentCharge[chargeName] && !isNaN(paymentCharge[chargeName])) {
              paymentCharge.aboveThreshold[chargeName] = true;
            }
          });
          deductibles[chargeName] = deductibleCharge;
        } else if (deductibleCharge > loss[chargeName]) {
          // Do Nothing
        } else if ((insuranceThreshold >= loss[chargeName]) && (loss[chargeName] > deductibleCharge) && (deductibleCharge !== 0)) {
          charges.forEach((paymentCharge) => {
            if (!paymentCharge.aboveDeductibles) {
              paymentCharge.aboveDeductibles = {};
            }
            if (paymentCharge[chargeName] && !isNaN(paymentCharge[chargeName])) {
              paymentCharge.aboveDeductibles[chargeName] = true;
            }
          });
          deductibles[chargeName] = deductibleCharge;
        } else if (loss[chargeName] > insuranceThreshold && insuranceThreshold !== 0) {
          charges.forEach((paymentCharge) => {
            if (!paymentCharge.aboveThreshold) {
              paymentCharge.aboveThreshold = {};
            }
            if (paymentCharge[chargeName] && !isNaN(paymentCharge[chargeName])) {
              paymentCharge.aboveThreshold[chargeName] = true;
            }
          });
          deductibles[chargeName] = deductibleCharge;
        } else if (deductibleCharge > insuranceThreshold) {
          logger.error(`Deductible (${deductibleCharge}) cannot be greater that insuranceThreshold (${insuranceThreshold})`);
        } else {
          logger.info('Deductible set to zero');
        }
      });

      const totalDeductible = Object.keys(deductibles).reduce((acc, charge) => {
        acc += deductibles[charge];
        return acc;
      }, 0);
      const totalLoss = Object.keys(loss).reduce((acc, charge) => {
        acc += loss[charge];
        return acc;
      }, 0);
      charges.forEach((paymentCharge) => {
        paymentCharge.deductibleCharge = Deductibles
          .getBifurcatedCharges(totalDeductible,
            destinationTotals[paymentCharge.destinationId], totalLoss) || 0;
      });
    }
    return charges;
  }
  static getBifurcatedCharges(total, destinationloss, totalLoss) {
    return (total * (destinationloss / totalLoss));
  }
}
module.exports = Deductibles;
